import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { useCallback, useEffect, useRef } from 'react';
import { useChartData } from '../context/ChartContext';
import Button from '../elements/Button';
import CloseButton from '../elements/CloseButton';
import Label from '../elements/Label';
import FormikForm from '../elements/formik/FormikForm';
import FormikInput from '../elements/formik/FormikInput';
import Events from '../utility/Events';
import { exportAsMatrix } from '../utility/export';
import { ModalStyles } from './ModalStyle';
const INITIAL_VALUE = { from: -1, to: 1, nbPoints: 1024 };
function ExportAsMatrixModal({ onClose = () => null, }) {
    const refForm = useRef();
    const { data } = useChartData();
    const handleSave = useCallback(() => {
        refForm.current.submitForm();
    }, []);
    const submitHandler = useCallback((options) => {
        exportAsMatrix(data, options, 'fileName');
        onClose();
    }, [data, onClose]);
    useEffect(() => {
        function handler(event) {
            const [from, to] = event.range;
            refForm.current.setValues({ ...refForm.current.values, from, to });
        }
        Events.on('brushEnd', handler);
        return () => {
            Events.off('brushEnd', handler);
        };
    }, []);
    return (_jsxs("div", { css: ModalStyles, children: [_jsxs("div", { className: "header handle", children: [_jsx("span", { children: "Export spectra as a Matrix" }), _jsx(CloseButton, { onClick: onClose, className: "close-bt" })] }), _jsx("div", { className: "inner-content", children: _jsxs(FormikForm, { ref: refForm, initialValues: INITIAL_VALUE, onSubmit: submitHandler, children: [_jsxs("div", { className: "row margin-10", children: [_jsx("span", { className: "custom-label", children: "Range :" }), _jsx(Label, { title: "From : ", children: _jsx(FormikInput, { name: "from", type: "number" }) }), _jsx(Label, { title: "To : ", children: _jsx(FormikInput, { name: "to", type: "number" }) })] }), _jsx("div", { className: "row margin-10", children: _jsx(Label, { title: "Number of Points :", className: "custom-label", children: _jsx(FormikInput, { name: "nbPoints", type: "number" }) }) })] }) }), _jsx("div", { className: "footer-container", children: _jsx(Button.Done, { onClick: handleSave, children: "Export Now" }) })] }));
}
export default ExportAsMatrixModal;
